import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../utils/translations';
import {INBOX_URL} from '../../../constants';

import './RequestText.less';

export class RequestText extends React.PureComponent {
    static propTypes = {
        confirmed: PropTypes.bool,
        email: PropTypes.string,
        hostName: PropTypes.string,
        instantBooking: PropTypes.boolean,
        isIpm: PropTypes.boolean,
        isVrbexNative: PropTypes.bool,
        isVrboIpmStaticMessaging: PropTypes.boolean,
        reservationId: PropTypes.string,
        translations: PropTypes.shape({}).isRequired,
        tripDetailsUrl: PropTypes.string,
    };

    static defaultProps = {
        hostName: '',
        isIpm: false,
        translations: {},
    };

    renderRequestText(
        email,
        hostName,
        instantBooking,
        isIpm,
        isVrboIpmStaticMessaging,
        reservationIdText,
        translations
    ) {
        if (isVrboIpmStaticMessaging) {
            const requestTextOne = email
                ? translate(
                      translations,
                      'trav-dash/trav-home',
                      'messages',
                      isIpm
                          ? 'th.confirmation.email.sent.forIpm.instantBooking.text1'
                          : 'th.confirmation.email.sent',
                      {
                          email,
                      }
                  )
                : '';
            const requestTextTwo = translate(
                translations,
                'trav-dash/trav-home',
                'messages',
                instantBooking
                    ? 'th.confirmation.email.sent.forIpm.instantBooking.text2'
                    : 'th.confirmation.email.sent.forIpm.not.instantBooking.text',
                {hostName: `<strong>${hostName}</strong>`}
            );
            return (
                <div className={`${isIpm ? 'RequestText__subText' : ''}`}>
                    <span
                        className="RequestText__text"
                        dangerouslySetInnerHTML={{
                            __html: email
                                ? `${reservationIdText} ${requestTextOne}`
                                : `${reservationIdText} `,
                        }}
                    />
                    {!isIpm && email ? (
                        <p className="RequestText__email">
                            <strong>{email}</strong>
                        </p>
                    ) : (
                        <span
                            className="RequestText__text"
                            dangerouslySetInnerHTML={{
                                __html: `${requestTextTwo}`,
                            }}
                        />
                    )}
                </div>
            );
        }

        return (
            <div>
                <span
                    dangerouslySetInnerHTML={{
                        __html: email
                            ? `${reservationIdText} ${translate(
                                  translations,
                                  'trav-dash/trav-home',
                                  'messages',
                                  'th.confirmation.email.sent'
                              )}`
                            : reservationIdText,
                    }}
                />
                {email && (
                    <p className="RequestText__email">
                        <strong>{email}</strong>
                    </p>
                )}
            </div>
        );
    }

    render() {
        const {
            confirmed,
            email,
            hostName,
            instantBooking,
            isIpm,
            isVrbexNative,
            isVrboIpmStaticMessaging,
            reservationId,
            translations,
            tripDetailsUrl,
        } = this.props;

        const reservationIdText = translate(
            translations,
            'trav-dash/trav-home',
            'messages',
            'th.confirmation.reservation.id',
            {
                id: `<a href=${
                    !isVrbexNative ? tripDetailsUrl : INBOX_URL
                }>${reservationId}</a>`,
            }
        );

        let title;

        if (confirmed) {
            title = translate(
                translations,
                'trav-dash/trav-home',
                'messages',
                'th.confirmation.reservation.title'
            );
        } else {
            title = translate(
                translations,
                'trav-dash/trav-home',
                'messages',
                'th.confirmation.request.title'
            );
        }

        /* eslint-disable react/no-danger */
        return (
            <div className="RequestText">
                <h1>{title}</h1>
                {this.renderRequestText(
                    email,
                    hostName,
                    instantBooking,
                    isIpm,
                    isVrboIpmStaticMessaging,
                    reservationIdText,
                    translations
                )}
            </div>
        );
        /* eslint-enable react/no-danger */
    }
}
